// Рантайм-загрузчик пред-сгенерированного пака эндлесс-уровней.
// Генерация — dev-only (tools/gen, Rust), в бандл не входит.
import { Tile } from './types';
import { LEVELS } from './levels';
import pack from './levels-endless.json';

const PACK = pack.length;
const PLATEAU_START = 60;               // == curve.rs PLATEAU_START

interface PackLevel { t: number[][]; h: number; w: number }
const DATA = pack as unknown as PackLevel[];

function packIndex(levelIdx: number): number {
  const g = levelIdx - LEVELS.length;
  if (g < PACK) return g;
  return PLATEAU_START + (g - PACK) % (PACK - PLATEAU_START);
}

export interface EndlessLevel { tiles: Tile[]; maxRowX2: number; maxColX2: number }

let cache: { levelIdx: number; level: EndlessLevel } | null = null;

export function getEndlessLevel(levelIdx: number): EndlessLevel {
  if (cache === null || cache.levelIdx !== levelIdx) {
    const L = DATA[packIndex(levelIdx)];
    const tiles: Tile[] = L.t.map((a, i) => ({
      id: i, type: a[3], row: a[0] / 2, col: a[1] / 2, layer: a[2],
    }));
    cache = { levelIdx, level: { tiles, maxRowX2: L.h, maxColX2: L.w } };
  }
  return cache.level;
}

export function getLevelDims(levelIdx: number): { maxRowX2: number; maxColX2: number } {
  if (levelIdx < LEVELS.length) {
    const def = LEVELS[levelIdx];
    return { maxRowX2: def.maxRowX2, maxColX2: def.maxColX2 };
  }
  const L = DATA[packIndex(levelIdx)];
  return { maxRowX2: L.h, maxColX2: L.w };
}
